// @flow
import type {CopyableSearchResult, Account} from 'docs/data';

// The ?![^a] is to prevent anything like 'test connect' from matching
const TEST_CARD_REGEX = /(test\s*c(?![^a])a?r?d?s?|card te?s?t?i?n?g?)/i;

type RawCopyableResult = {|
  title: string,
  copyable: (account: Account) => string,
  id: string,
  match: Array<RegExp>,
|};

// The "id" is what is tracked for analytics
const copyableResults: Array<RawCopyableResult> = [
  {
    title: 'Test card: Successful payment',
    copyable: () => '4242 4242 4242 4242',
    id: 'copyable-test-card-succesful-payment',
    match: [TEST_CARD_REGEX, /succesful payment/i, /424?2?/],
  },
  {
    title: 'Test card: 3DS authentication needed',
    copyable: () => '4040 4040 4040 4040',
    id: 'copyable-test-card-authentication-needed',
    match: [TEST_CARD_REGEX, /3ds authentication/i, /404?0?/],
  },
  {
    title: 'Test card: Failed payment',
    copyable: () => '1234 5679 0123 4567',
    id: 'copyable-test-card-failed-payment',
    match: [TEST_CARD_REGEX, /failed payment/i, /1234/],
  },
  {
    title: 'Test publishable key',
    copyable: (account: Account) => account.keys.publishable,
    id: 'copyable-test-publishable-key',
    match: [/^(api|publi.*)?key/i, /api(_| |)?ke?y?/i],
  },
  {
    title: 'Test secret key',
    copyable: (account: Account) => account.keys.secret,
    id: 'copyable-test-secret-key',
    match: [/^(api|secr.*)?key/i, /api(_| |)?ke?y?/i],
  },
];

const rawCopyableResultToSearchResult = (
  result: RawCopyableResult,
  account: Account,
) => ({
  title: result.title,
  content: result.copyable(account),
  type: 'copyable',
  id: result.id,
  isExternal: false,
});

export const queryCopyableResults: (
  query: string,
  account: Account,
) => Array<CopyableSearchResult> = (query, account) => {
  return copyableResults
    .filter((item: RawCopyableResult) => {
      return item.match.filter((pattern) => pattern.test(query)).length > 0;
    })
    .map((result) => rawCopyableResultToSearchResult(result, account));
};
